import './index.less';

import commonMsg from 'messages';
import loginMsg from 'messages/Login';
import { Button, Icon, Input } from '@beehive/components';
import PropTypes from 'prop-types';
import React, { ChangeEvent } from 'react';
import Captcha from './Captcha';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import { isBlank } from 'utils';
import * as actions from 'modules/actions/account';

const messages = {...commonMsg, ...loginMsg};
export interface ForgetPwdProps {
  prefixCls?: string;
  forgetPwd: Function;
}
class ForgetPwd extends React.Component<ForgetPwdProps, any> {
  private refreshRef: any;
  static contextTypes = {
    intl: PropTypes.object,
  };
  static defaultProps = {
    prefixCls: 'mpc-external-login-forget-pwd',
  };
  constructor(props: ForgetPwdProps) {
    super(props);
    this.state = {};
  }
  handleSubmit = () => {
    const { intl } = this.context;
    const { forgetPwd } = this.props;
    const { login, email, verifyCode } = this.state;
    const alertMsg = this.getAlertMsg();
    if (alertMsg) {
      return;
    }
    this.setState({ submitLoading: true });
    const body = {
      login,
      email,
      _rucaptcha: verifyCode,
    };
    forgetPwd(body).then((res: any) => {
      if (res.res_code === 1) {
        this.setState({ showIconPage: true, submitLoading: false });
      } else if (res.res_code === 0) {
        this.refreshRef({
          locale: intl.locale,
          onChange: this.handleChange,
        });
        this.setState({ alertMsg: res.res_msg, verifyCode: null, submitLoading: false });
      }
    });
  }
  handleChange = (newVal: { [key: string]: any }) => {
    const { errorKey, alertMsg } = this.state;
    let newErrorKey = errorKey;
    let newAlertMsg = alertMsg;
    if (!!~Object.keys(newVal).indexOf(errorKey)) {
      newErrorKey = null;
      newAlertMsg = null;
    }
    const val = {
      ...this.state,
      ...newVal,
      errorKey: newErrorKey,
      alertMsg: newAlertMsg,
    };
    this.setState(val);
  }
  getRefreshRef = (refresh: any) => {
    this.refreshRef = refresh;
  }
  getAlertMsg = () => {
    const { intl } = this.context;
    const { login, email, verifyCode } = this.state;
    let alertMsg = null;
    let errorKey = null;
    switch (true) {
      case isBlank(login): {
        alertMsg = intl.formatMessage(messages.inputUserName);
        errorKey = 'login';
        break;
      }
      case isBlank(email): {
        alertMsg = intl.formatMessage(messages.inputEmail);
        errorKey = 'email';
        break;
      }
      case isBlank(verifyCode): {
        alertMsg = intl.formatMessage(messages.captchaAlertMsg);
        errorKey = 'verifyCode';
        break;
      }
      default: {
        //
      }
    }
    this.setState({ alertMsg, errorKey });
    return alertMsg;
  }
  render() {
    const { intl } = this.context;
    const { prefixCls } = this.props;
    const { login, email, alertMsg, errorKey, showIconPage, submitLoading } = this.state;
    return showIconPage ? (
      <div className={`mpc-external-login mpc-external-login-wrap ${prefixCls}-wrap`}>
        <div className="verify-messages">
          <Icon name="check-circle-o" size={80}/>
          <div className="verify-title">{intl.formatMessage(messages.verifySuccess)}</div>
          <div className="verify-info">{intl.formatMessage(messages.modifyLink)}</div>
        </div>
      </div>
    ) : (
      <div className={`mpc-external-login mpc-external-login-wrap ${prefixCls}-wrap`}>
        <div className={`${prefixCls}-title strong`}>{intl.formatMessage(messages.forgetPwd)}</div>
        <Input
          onChange={(e: ChangeEvent<HTMLInputElement>) => this.handleChange({ login: e.target.value })}
          className={`mpc-external-login-form-item ${errorKey === 'login' ? 'show-error' : ''}`}
          placeholder={intl.formatMessage(messages.accountPlaceholder)}
          prefix={<Icon name="user-o" />}
          value={login}
        />
        <Input
          onChange={(e: ChangeEvent<HTMLInputElement>) => this.handleChange({ email: e.target.value })}
          className={`mpc-external-login-form-item ${errorKey === 'email' ? 'show-error' : ''}`}
          placeholder={intl.formatMessage(messages.emailPlaceholder)}
          prefix={<Icon name="envelope-o" />}
          value={email}
        />
        <Captcha locale={intl.locale} onChange={this.handleChange} getRefreshRef={this.getRefreshRef}/>
        <div className={`${prefixCls}-alert-msg mpc-external-login-alert-msg`}>
          {
            alertMsg && <Icon name="exclamation-circle-o" />
          }
          {alertMsg}
        </div>
        <Button
          type="primary"
          className={`${prefixCls}-next-btn`}
          onClick={this.handleSubmit}
          disabled={submitLoading}
        >
          {intl.formatMessage(messages.nextStep)}
        </Button>
      </div>
    );
  }
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AccountActions>) {
  return bindActionCreators({
    forgetPwd: actions.forgetPwd,
  }, dispatch);
}

export default connect(undefined, mapDispatchToProps)(ForgetPwd);
